module.exports = __webpack_public_path__ + "static/media/star.274df83e.svg";